import { Theme } from '@material-ui/core/styles';

export const getMuiDialogActions = (theme: Theme): Record<string, unknown> => ({
  MuiDialogActions: {
    root: {
      borderTop: `1px solid ${theme.palette.grey[400]}`,
    },
  },
});
